/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMcpEndpointsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMcpEndpointsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMcpEndpointsSecurity = {
  option1?: ListMcpEndpointsSecurityOption1 | undefined;
  option2?: ListMcpEndpointsSecurityOption2 | undefined;
};

export type ListMcpEndpointsRequest = {
  /**
   * Optional filter: only return endpoints associated with this MCP server.
   */
  mcpServerId?: string | undefined;
  /**
   * Optional filter: only return endpoints associated with this meta MCP server.
   */
  metaMcpServerId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMcpEndpointsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMcpEndpointsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListMcpEndpointsSecurityOption1$Outbound,
  ListMcpEndpointsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listMcpEndpointsSecurityOption1ToJSON(
  listMcpEndpointsSecurityOption1: ListMcpEndpointsSecurityOption1,
): string {
  return JSON.stringify(
    ListMcpEndpointsSecurityOption1$outboundSchema.parse(
      listMcpEndpointsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMcpEndpointsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMcpEndpointsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListMcpEndpointsSecurityOption2$Outbound,
  ListMcpEndpointsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listMcpEndpointsSecurityOption2ToJSON(
  listMcpEndpointsSecurityOption2: ListMcpEndpointsSecurityOption2,
): string {
  return JSON.stringify(
    ListMcpEndpointsSecurityOption2$outboundSchema.parse(
      listMcpEndpointsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMcpEndpointsSecurity$Outbound = {
  Option1?: ListMcpEndpointsSecurityOption1$Outbound | undefined;
  Option2?: ListMcpEndpointsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMcpEndpointsSecurity$outboundSchema: z.ZodMiniType<
  ListMcpEndpointsSecurity$Outbound,
  ListMcpEndpointsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMcpEndpointsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMcpEndpointsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMcpEndpointsSecurityToJSON(
  listMcpEndpointsSecurity: ListMcpEndpointsSecurity,
): string {
  return JSON.stringify(
    ListMcpEndpointsSecurity$outboundSchema.parse(listMcpEndpointsSecurity),
  );
}

/** @internal */
export type ListMcpEndpointsRequest$Outbound = {
  mcp_server_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMcpEndpointsRequest$outboundSchema: z.ZodMiniType<
  ListMcpEndpointsRequest$Outbound,
  ListMcpEndpointsRequest
> = z.pipe(
  z.object({
    mcpServerId: z.optional(z.string()),
    metaMcpServerId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMcpEndpointsRequestToJSON(
  listMcpEndpointsRequest: ListMcpEndpointsRequest,
): string {
  return JSON.stringify(
    ListMcpEndpointsRequest$outboundSchema.parse(listMcpEndpointsRequest),
  );
}
